import { LoadingContainer, LoadingContent, LoadingStyleType } from "./styles";

const Loading = (props: LoadingStyleType) => {
  return (
    <LoadingContainer {...props}>
      <LoadingContent />
    </LoadingContainer>
  );
};

export default Loading;
